/*
  capsule-filter.js
  Tag filter chips for the cocktail makers capsule carousel.

  Markup contract:
  - [data-capsule-filter]          wraps chips + carousel; data-filter-limit = max items per filter
  - [data-filter-value]            chip button; value is a tag handle (handleized in Liquid), or "all"
  - [data-pc-track] > li[data-tags] carousel items; data-tags is the product's tag handles joined with "|"
  - [data-filter-empty]            message shown when nothing matches

  Hidden items drop their [data-pc-item] attribute so paginated-carousel.js
  keeps measuring a visible item for step size and progress.
*/
(function () {
  function initCapsuleFilter(root) {
    if (root.dataset.capsuleFilterInit === 'true') return;
    root.dataset.capsuleFilterInit = 'true';

    const chips = root.querySelectorAll('[data-filter-value]');
    const track = root.querySelector('[data-pc-track]');
    const empty = root.querySelector('[data-filter-empty]');
    if (!chips.length || !track) return;

    const items = Array.from(track.children);
    const limit = parseInt(root.dataset.filterLimit, 10) || Infinity;

    root.addEventListener('click', e => {
      const chip = e.target.closest('[data-filter-value]');
      if (!chip || !root.contains(chip)) return;

      const value = chip.dataset.filterValue;
      chips.forEach(c => c.setAttribute('aria-pressed', String(c === chip)));

      // Show the first `limit` matches in collection order; hide everything else
      let shown = 0;
      items.forEach(item => {
        const tags = (item.dataset.tags || '').split('|');
        const match = value === 'all' || tags.includes(value);
        const visible = match && shown < limit;
        item.hidden = !visible;
        if (visible) {
          item.setAttribute('data-pc-item', '');
          shown++;
        } else {
          item.removeAttribute('data-pc-item');
        }
      });

      if (empty) empty.hidden = shown > 0;
      track.scrollTo({ left: 0, behavior: 'instant' });
      track.dispatchEvent(new Event('scroll')); // resync carousel arrows + progress
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-capsule-filter]').forEach(initCapsuleFilter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', e => initAll(e.target));

  window.CapsuleFilter = { init: initCapsuleFilter, initAll };
})();